export const choicesData = [
  {
    title: "Take all your money in one go",
    description: "Take all your money as a single cash lump sum.",
    iconname: "money_in_one_go",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription: "25% tax-free and 75% taxed as your income.",
        subDescription: [],
      },
      {
        subTitle: "Things to consider",
        subDescription: [
          "Ensure you have a financial plan for this money",
          "If your pot is less than £10,000 and you are leaving the plan, we will process as a ‘small pot’ if eligible",
        ],
      },
    ],
  },
  {
    title: "Take tax-free cash and invest the rest",
    description:
      "Take some or all of your tax-free pension savings as an income or lump sum and move the related taxable portion to a TPT drawdown account.",
    iconname: "tax_free_cash",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription:
          "For every £1 of tax-free cash you take, we’ll move £3 into a TPT drawdown account, where you can keep your money invested until you need it.",
        subDescription: [],
      },
      {
        subTitle: "Things to consider",
        subDescription: [
          "Taking all your tax-free cash as lump sum will mean the rest is taxable when you take it.",
          "Taking tax-free cash gradually as an income could supplement your other income without paying more tax.",
          "If you have more than one TPT pot, consider combining them before you apply, for a single drawdown account in retirement.",
        ],
      },
    ],
  },
  {
    title: "Take your money in chunks, a bit at a time",
    description: "Make lump sum withdrawals from your pension pot.",
    iconname: "money_in_chunks",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription:
          "For each withdrawal, 25% is tax-free and 75% is taxed as your income. This is also known as an ‘uncrystallised fund pension lump sum’ (UFPLS).",
        subDescription: [],
      },
      {
        subTitle: "Things to consider",
        subDescription: [
          "Have a financial plan for the use of your pension chunk",
          "Your remaining pension pot stays invested, so please continue to review your investments and target retirement age",
        ],
      },
    ],
  },
  {
    title: "Take a guaranteed income (annuity)",
    description:
      "Buy a guaranteed regular income from an insurance company for the rest of your life or fixed term.",
    iconname: "future_annuity",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription:
          "Up to 25% can be taken tax-free and you instruct us to pay the rest of your pension to an insurance company to buy your guaranteed income.",
        subDescription: [],
      },

      {
        subTitle: "Things to consider",
        subDescription: [
          "The most secure retirement income option but can’t be changed after purchase.",
          "Shop around for the best annuity income quote for your circumstances.",
          "Enhanced terms (improved income) can be found for some health conditions.",
        ],
      },
    ],
  },
  {
    title: "Take a regular income from TPT drawdown",
    description:
      "Choice of income with payments managed for you for life or a fixed term, or income at the rate of your choice that you manage yourself.",
    iconname: "regular_income",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription:
          "Up to 25% can be taken tax-free, the rest is moved to TPT drawdown to receive taxable income.",
        subDescription: [
          "Managed income - managed for you to last your lifetime (to age 95).",
          "Future annuity income  - managed for you to age 75, before an annuity.",
          "Flexi-access - self-managed where you choose your income and drawdown investment.",
        ],
      },

      {
        subTitle: "Things to consider",
        subDescription: [
          "Managed for you income can vary depending on investment performance",
          "Flexi-access is initially invested the same way as your existing pension savings. Please review regularly.",
          "How long flexi-access income will last depends on your chosen level of income and investment performance.",
          "You can change your income, investments and take taxable withdrawals at any time.",
        ],
      },
    ],
  },
  {
    title: "Mix and match",
    description:
      "Personalise your own blend of cash lump sum, drawdown and income.",
    iconname: "mix_and_match",
    innerContent: [
      {
        subTitle: "How it works",
        howItWorksDescription:
          "You are in control. You choose the portion to receive as a cash lump sum (25% tax-free, remainder taxable) and how to use the rest from drawdown.",
        subDescription: [],
      },
      {
        subTitle: "Things to consider",
        subDescription: [
          "We’ll pay up to 25% tax-free",
          "Remainder will be moved to drawdown to pay out as additional (taxable) cash, invested or paid as income and/or annuity.",
          "Flexi-access is initially invested the same way as your existing pension savings. Please review regularly.",
          "How long your drawdown lasts depends on how you manage its investment and your chosen income.",
        ],
      },
    ],
  },
];
